import { useContext } from "react";
import { store } from "../../store";

const useRoutes = () => {
  const { routes, setRoutes } = useContext(store);

  return { routes, setRoutes };
};

export default useRoutes;
